var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-one-third"},[_c('div',{staticClass:"has-padding"},[_c('div',{staticClass:"box"},[_c('Login')],1)])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }